/**
 * « Vu » live (« Ton mélange », validated by Maude on 31/10/2026): when
 * somebody else reads, their id joins those messages' readers, and the « Vu »
 * under the last message is drawn again from that, as it is at opening.
 *
 * My own readings are left out: this screen marked them itself when it sent
 * them, and a reading on my other phone does not change what this one shows.
 * Messages of another conversation are left alone, whatever the ids say.
 */
export function afterSomebodyRead<T extends { _id: string; chatId: string; readByUserIds: string[] }>(
  messages: T[],
  read: { chatId: string; userId: string; messageIds: string[] },
  myUserId: string | null | undefined,
): T[] {
  if (!read?.userId || read.userId === myUserId) {
    return messages;
  }
  const ids = new Set(read.messageIds ?? []);
  let changed = false;
  const after = messages.map((message) => {
    if (message.chatId !== read.chatId || !ids.has(message._id) || message.readByUserIds.includes(read.userId)) {
      return message;
    }
    changed = true;
    return { ...message, readByUserIds: [...message.readByUserIds, read.userId] };
  });
  return changed ? after : messages;
}
